import FuseNavigation from '@/@fuse/core/FuseNavigation';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const Navigation = ({ active, className, dense, layout = 'vertical' }) => {
	const navigation = useSelector(({ fuse }) => fuse.navigation);
	// Per-school feature flag — hide the Billing menu entirely when off.
	// School lives at user.data.school (login) or user.school (super_school_admin).
	const billingEnabled = useSelector(
		({ auth }) => (auth?.user?.data?.school ?? auth?.user?.school)?.billing_enabled,
	);

	const filteredNavigation = useMemo(
		() => (billingEnabled ? navigation : navigation.filter((item) => item.id !== 'billing')),
		[navigation, billingEnabled],
	);

	return (
		<FuseNavigation
			active={active}
			className={clsx('navigation', className)}
			dense={dense}
			layout={layout}
			navigation={filteredNavigation}
		/>
	);
};

export default Navigation;
